module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_train_color_skyblue-c41b36323be6b8cf4e1d9ce30ea16458.svg";